import { render, staticRenderFns } from "./NarrativeSectionParagraphs.vue?vue&type=template&id=c2120890"
import script from "./NarrativeSectionParagraphs.vue?vue&type=script&lang=js"
export * from "./NarrativeSectionParagraphs.vue?vue&type=script&lang=js"
import style0 from "./NarrativeSectionParagraphs.vue?vue&type=style&index=0&id=c2120890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports